var _defs, _line, _line2, _line3, _line4, _polygon, _line5, _line6, _line7, _line8, _line9, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-4{stroke:#0090b9;}.cls-1{stroke-width:1.88px;}.cls-2{fill:#b3ddee;}.cls-3{stroke:#b3ddee;}.cls-3,.cls-4{stroke-width:2px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.43,
    y1: 30.75,
    x2: 23.98,
    y2: 30.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.84,
    y1: 42.02,
    x2: 33.54,
    y2: 42.02
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4,
    y1: 54.94,
    x2: 25.44,
    y2: 54.94
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.22,
    y1: 69.66,
    x2: 6.18,
    y2: 69.66
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "156.71 47.05 139.45 47.05 151.13 32.54 168.39 32.54 156.71 47.05"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.43,
    y1: 58.59,
    x2: 113.15,
    y2: 58.59
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 68.25,
    y1: 64.6,
    x2: 105.97,
    y2: 64.6
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 61.06,
    y1: 70.13,
    x2: 98.78,
    y2: 70.13
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 62.42,
    y1: 35.32,
    x2: 82.71,
    y2: 35.32
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 57.93,
    y1: 40.71,
    x2: 78.22,
    y2: 40.71
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.05,91.82H13.15a1.36,1.36,0,0,1-1.09-2.16L57.6,28.15a1.34,1.34,0,0,1,1.09-.55H174.58a1.35,1.35,0,0,1,1.09,2.16L130.13,91.27A1.32,1.32,0,0,1,129.05,91.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature7);
export default __webpack_public_path__ + "static/media/feature7.e77e2c6e90876d8902fec491d06787c6.svg";
export { ForwardRef as ReactComponent };